import type { FC } from 'react';
import React, { Children, isValidElement } from 'react';

import { getFeatureOptionByName } from 'src/utils/featureToggle';
import type { VariantProps, ExperimentProps } from './types';

const Variant: FC<VariantProps> = ({ children }) => <>{children}</>;

const Experiment = ({ name, children }: ExperimentProps): JSX.Element => {
  const optionToShow = getFeatureOptionByName(name);

  return (
    <>
      {Children.map(children, (child) =>
        isValidElement(child) && child.props.option === optionToShow
          ? child
          : null,
      )}
    </>
  );
};

export { Experiment, Variant };
